
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  withMobileDialog,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Snackbar,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import {
  STATUS_SETTINGS_INFORMATION,
  EVENT_DATA_SETTINGS_INFORMATION,
  EVENT_TEMPLATE_SETTINGS_INFORMATION,
  TAG_SETTINGS_INFORMATION,
  USER_ONBOARDING,
  ADMIN_ONBOARDING,
} from './tutorials';
import StatusInfoCard from './InformationCards/StatusInfoCard';
import EventDataInformationCard from './InformationCards/EventDataInformationCard';
import EventTemplateInformationCard from './InformationCards/EventTemplateInformationCard';
import TagInformationCard from './InformationCards/TagInformationCard';

import { updateMySeenTutorials } from '../../redux/user/actions';

export class TutorialsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hide: false };
  }

  updateMySeenTutorials = (callback) => {
    const newSeenTutorials = this.props.seenTutorials;
    if (!newSeenTutorials[this.props.tutorial]) {
      newSeenTutorials[this.props.tutorial] = [this.props.version];
    } else if (newSeenTutorials[this.props.tutorial].indexOf(this.props.version) === -1) {
      newSeenTutorials[this.props.tutorial].push(this.props.version);
    } else {
      return;
    }
    this.props.updateMySeenTutorials({ tutorialsSeen: newSeenTutorials }).then(() => {
      if (callback !== undefined) {
        callback();
      }
    });
  }

  isTutorialOpen = () => {
    if (this.props.openTutorial) {
      return true;
    }

    if (
      this.props.seenTutorials
        && (!this.props.seenTutorials[this.props.tutorial]
        || this.props.seenTutorials[this.props.tutorial].indexOf(this.props.version) === -1)
    ) {
      this.props.handleOpen();
      this.updateMySeenTutorials();
      return true;
    }

    return false;
  }

  isSnackbarOpen = (hide) => {
    const skipTutorialExpiration = global.window.localStorage.getItem(`skip_${this.props.tutorial}${this.props.version}`) || new Date(0);
    const expirationTime = new Date(skipTutorialExpiration);
    const now = new Date();
    if (!hide && expirationTime <= now
       && this.props.seenTutorials && (!this.props.seenTutorials[this.props.tutorial]
          || this.props.seenTutorials[this.props.tutorial].indexOf(this.props.version) === -1)) {
      global.window.localStorage.removeItem(`skip_${this.props.tutorial}${this.props.version}`);
      return true;
    }
    return false;
  }

  skipTutorialForNow = () => {
    // hide for 6 hours
    global.window.localStorage.setItem(`skip_${this.props.tutorial}${this.props.version}`, new Date(new Date().getTime() + (360 * 60 * 1000)));
    this.setState({ hide: true });
  }

  renderSwitch() {
    switch (this.props.tutorial) {
      case STATUS_SETTINGS_INFORMATION:
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.isTutorialOpen()}
            onClose={this.props.handleClose}
            maxWidth="lg"
          >
            <DialogTitle>Information About Statuses</DialogTitle>
            <DialogContent>
              <StatusInfoCard />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.props.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      case EVENT_DATA_SETTINGS_INFORMATION:
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.isTutorialOpen()}
            onClose={this.props.handleClose}
            maxWidth="lg"
          >
            <DialogTitle>Information About Custom Fields Fields</DialogTitle>
            <DialogContent>
              <EventDataInformationCard />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.props.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      case EVENT_TEMPLATE_SETTINGS_INFORMATION:
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.isTutorialOpen()}
            onClose={this.props.handleClose}
            maxWidth="lg"
          >
            <DialogTitle>Information About Workflows</DialogTitle>
            <DialogContent>
              <EventTemplateInformationCard />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.props.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      case TAG_SETTINGS_INFORMATION:
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.isTutorialOpen()}
            onClose={this.props.handleClose}
            maxWidth="lg"
          >
            <DialogTitle>Information About Tags</DialogTitle>
            <DialogContent>
              <TagInformationCard />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.props.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      case USER_ONBOARDING:
        return (
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={this.isSnackbarOpen(this.state.hide)}
            ContentProps={{ 'aria-describedby': 'message-id' }}
            message={<span id="message-id">Welcome to Pingum!</span>}
            action={[
              <Button style={{ margin: 5 }} key="setup" color="primary" variant="outlined" size="small" onClick={() => { this.updateMySeenTutorials(() => { window.location.href = '/user-onboarding'; }); }}>
                Setup your account
              </Button>,
              <Tooltip key="skipnow" title="Never show me this again" position="bottom">
                <Button style={{ margin: 5 }} color="secondary" size="small" onClick={() => this.updateMySeenTutorials()}>
                  Skip
                </Button>
              </Tooltip>,
              <Tooltip key="close" title="Remind me later" position="bottom">
                <IconButton
                  aria-label="Close"
                  color="inherit"
                  onClick={this.skipTutorialForNow}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>,
            ]}
          />
        );
      case ADMIN_ONBOARDING:
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.isTutorialOpen()}
            onClose={this.props.handleClose}
            maxWidth="md"
          >
            <DialogTitle>Welcome to your dashboard!</DialogTitle>
            <DialogContent>
              <Typography variant="body1" gutterBottom>
                The dashboards page is where you can view and manage all your Pingum workflows and events.
                You can filter groupings of workflows into new dashboards for easy management.
              </Typography>
              <Typography variant="h3">Want to configure your setup?</Typography>
              <Typography variant="body1" gutterBottom>
                To change your Pingum workflows navigate to <a href="/settings/workflows">Settings &#62; Workflows</a>.<br />
                To configure event settings (statuses, custom fields, tags) navigate to <a href="/settings/events">Settings &#62; Events</a>.<br />
                To manage and acccess your organization&#39;s public forms head to <a href="/settings/forms">Settings &#62; Forms</a>.
              </Typography>
              <Typography variant="caption">You can access all these pages anytime from the left side navigation.</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.props.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      default:
        return <span />;
    }
  }

  render() {
    return (
      <div>
        {this.renderSwitch()}
      </div>
    );
  }
}

TutorialsComponent.propTypes = {
  seenTutorials: PropTypes.object,
  tutorial: PropTypes.string,
  version: PropTypes.string,
  openTutorial: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  updateMySeenTutorials: PropTypes.func,
  fullScreen: PropTypes.bool,
};

TutorialsComponent.defaultProps = {
  seenTutorials: null,
  tutorial: '',
  version: '',
  openTutorial: false,
  handleClose: () => {},
  handleOpen: () => {},
  updateMySeenTutorials: () => Promise.resolve(),
  fullScreen: false,
};

export const mapStateToProps = (state) => ({ seenTutorials: state.user.seenTutorials });

export const mapDispatchToProps
  = (dispatch) => ({ updateMySeenTutorials: (request) => dispatch(updateMySeenTutorials(request)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog({ breakpoint: 'sm' })(TutorialsComponent));
